/**
 * DevExtreme (esm/__internal/grids/grid_core/context_menu/m_context_menu.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { getPublicElement } from "../../../../core/element";
import $ from "../../../../core/renderer";
import { each } from "../../../../core/utils/iterator";
import ContextMenu from "../../../../ui/context_menu";
import modules from "../m_modules";
const CONTEXT_MENU = "dx-context-menu";
const GROUP_ROW_CLASS = "dx-group-row";
const viewName = {
  columnHeadersView: "header",
  rowsView: "content",
  footerView: "footer",
  headerPanel: "toolbar"
};
const VIEW_NAMES = ["columnHeadersView", "rowsView", "footerView", "headerPanel"];
export class ContextMenuController extends modules.ViewController {
  init() {
    this.createAction("onContextMenuPreparing");
  }
  getContextMenuItems(dxEvent) {
    if (!dxEvent) {
      return false;
    }
    const that = this;
    const $targetElement = $(dxEvent.target);
    let menuItems;
    each(VIEW_NAMES, function () {
      const view = that.getView(this);
      if (!view) {
        return;
      }
      const $viewElement = view.element();
      const isTargetElementInsideView = (null === $viewElement || void 0 === $viewElement ? void 0 : $viewElement.is($targetElement)) || (null === $viewElement || void 0 === $viewElement ? void 0 : $viewElement.find($targetElement).length);
      if (isTargetElementInsideView) {
        var _$targetCellElement$, _rowOptions$cells, _view$getContextMenuI;
        const isGroupRow = $targetElement.hasClass("dx-group-row");
        const $targetCellElement = isGroupRow ? $targetElement.find(".dx-group-cell").first() : $targetElement.closest(".dx-row > td, .dx-row > tr");
        const $targetRowElement = $targetCellElement.parent();
        const rowIndex = view.getRowIndex($targetRowElement);
        const columnIndex = null === (_$targetCellElement$ = $targetCellElement[0]) || void 0 === _$targetCellElement$ ? void 0 : _$targetCellElement$.cellIndex;
        const rowOptions = $targetRowElement.data("options");
        const options = {
          event: dxEvent,
          targetElement: getPublicElement($targetElement),
          target: viewName[this],
          rowIndex: rowIndex,
          row: view._getRows()[rowIndex],
          columnIndex: columnIndex,
          column: null === rowOptions || void 0 === rowOptions || null === (_rowOptions$cells = rowOptions.cells) || void 0 === _rowOptions$cells || null === (_rowOptions$cells = _rowOptions$cells[columnIndex]) || void 0 === _rowOptions$cells ? void 0 : _rowOptions$cells.column
        };
        options.items = null === (_view$getContextMenuI = view.getContextMenuItems) || void 0 === _view$getContextMenuI ? void 0 : _view$getContextMenuI.call(view, options);
        that.executeAction("onContextMenuPreparing", options);
        that._contextMenuPrepared(options);
        menuItems = options.items;
        if (menuItems) {
          return false;
        }
      }
      return;
    });
    return menuItems;
  }
  _contextMenuPrepared(options) {}
}
export class ContextMenuView extends modules.View {
  init() {
    super.init();
    this._contextMenuController = this.getController("contextMenu");
  }
  _renderCore() {
    const $element = this.element().addClass(CONTEXT_MENU);
    this.setAria("role", "presentation", $element);
    this._createComponent($element, ContextMenu, {
      onPositioning: actionArgs => {
        const {
          event: event
        } = actionArgs;
        const contextMenuInstance = actionArgs.component;
        const items = this._contextMenuController.getContextMenuItems(event);
        if (items) {
          contextMenuInstance.option("items", items);
          event.stopPropagation();
        } else {
          actionArgs.cancel = true;
        }
      },
      onItemClick(params) {
        var _params$itemData, _params$itemData$onIt;
        null === (_params$itemData = params.itemData) || void 0 === _params$itemData || null === (_params$itemData$onIt = _params$itemData.onItemClick) || void 0 === _params$itemData$onIt || _params$itemData$onIt.call(_params$itemData, params);
      },
      cssClass: this.getWidgetContainerClass(),
      target: this.component.$element()
    });
  }
}
export const contextMenuModule = {
  defaultOptions: () => ({
    onContextMenuPreparing: null
  }),
  controllers: {
    contextMenu: ContextMenuController
  },
  views: {
    contextMenuView: ContextMenuView
  }
};